import { KeyResult } from "@/types";

export interface KrWeightSummary {
    total: number;
    weighted: number;
    unweighted: number;
    count: number;
}

/** Mirrors the BE rollup rule: weights are opt-in; KRs split equally until any sibling has weight > 0. */
export const summarizeKrWeights = (krs: KeyResult[]): KrWeightSummary => {
    const weighted = krs.filter(kr => (kr.weight ?? 0) > 0);
    return {
        total: weighted.reduce((sum, kr) => sum + (kr.weight ?? 0), 0),
        weighted: weighted.length,
        unweighted: krs.length - weighted.length,
        count: krs.length,
    };
};
